// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"efb4ce5d","80":"1ddf3d69","205":"b96dff52","364":"40793ce4","468":"f500ee02","503":"451ff412","528":"c8d05447","585":"c9e7ad11","664":"072fec63","990":"4788a130"}[chunkId] + ".chunk.js";
};